import { z } from 'zod'

const personNameSchema = z
  .string()
  .trim()
  .min(2, 'Минимум 2 символа')
  .max(60, 'Максимум 60 символов')
  .regex(/^[a-zA-Zа-яА-ЯёЁ\s-]+$/, 'Используйте только буквы, пробелы и дефисы')

export const profileFormSchema = z.object({
  gender: z.enum(['', 'male', 'female']),
  birthdayDate: z
    .string()
    .refine(
      (value) => !value || isValidBirthdayDate(value),
      'Некорректная дата рождения',
    ),
  name: personNameSchema,
  surname: personNameSchema,
})

export const profileDescriptionSchema = z
  .string()
  .trim()
  .max(500, 'Описание не может быть длиннее 500 символов')

export type ProfileForm = z.infer<typeof profileFormSchema>

export type ProfileUpdate = Readonly<{
  gender?: 'male' | 'female' | null
  birthdayDate: string | null
  description: string | null
  imagePath: string | null
  lang: string | null
  name: string
  surname: string | null
}>

export function dateForAge(today: Date, age: number): string {
  const parts = new Intl.DateTimeFormat('en', {
    timeZone: 'Europe/Samara',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(today)
  const part = (type: string) =>
    Number(parts.find((item) => item.type === type)?.value)
  const year = part('year') - age
  const month = part('month') - 1
  const day = Math.min(
    part('day'),
    new Date(Date.UTC(year, month + 1, 0)).getUTCDate(),
  )
  const result = new Date(Date.UTC(year, month, day))
  return result.toISOString().slice(0, 10)
}

export function isValidBirthdayDate(
  value: string,
  today = new Date(),
): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false
  const parsed = new Date(`${value}T00:00:00Z`)
  return (
    !Number.isNaN(parsed.valueOf()) &&
    parsed.toISOString().slice(0, 10) === value &&
    value >= dateForAge(today, 120) &&
    value <= dateForAge(today, 6)
  )
}
